import { render, staticRenderFns } from "./AgentSetup.vue?vue&type=template&id=7c4cdf8a"
import script from "./AgentSetup.vue?vue&type=script&lang=js"
export * from "./AgentSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports